import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function AEPSCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/aeps");
    }, 5000); // 5 seconds

    return () => clearTimeout(timer); // cleanup
  }, [navigate]);

  return (
   <main>
     <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h2>Processing AEPS Response...</h2>
      <p>Please wait, you will be redirected shortly.</p>
    </div>
   </main>
  );
}
